import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { ApiError } from '../error.model';

@Component({
  selector: 'error-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, DatePipe],
  templateUrl: './error-dialog.html',
})
export class ErrorDialog {
  protected data: ApiError = inject(MAT_DIALOG_DATA);
  protected showDetails = false;

  private dialogRef = inject(MatDialogRef<ErrorDialog>);
  private clipboard = inject(Clipboard);
  private snackBar = inject(MatSnackBar);

  get messageText(): string {
    return Array.isArray(this.data.message)
      ? this.data.message.join('; ')
      : this.data.message;
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  close(): void {
    this.dialogRef.close();
  }

  copyDetails(): void {
    this.clipboard.copy(this.data.data ?? '');
    this.snackBar.open('Copiado!', '✕', {
      duration: 1500,
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }
}
